<lib-modal-layout [title]="title" [subtitle]="''" [showClose]="false">
    <p class="text-center my-4">{{ message }}</p>
    <lib-payroll-classes [form]="data.form" [showTotalPayroll]="false"></lib-payroll-classes>
    @if (wizardStore.addAppropriateClassCodeError()) {
        <mat-error class="mb-4">When performing New Residential work, be sure to add the appropriate class codes.</mat-error>
    }
    <div class="text-center" btnPrimary>
        <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'" [text]="buttonText" [size]="'large'" [type]="'button'"
            [disabled]="disabled()" (click)="updateQuote()"></lib-button>
        <p class="mt-4 mb-2">Not ready to update? Come back later.</p>
    
        <lib-button [cssType]="'btn-secondary'" [text]="data.returnText" [size]="'small'" [type]="'button'"
                (click)="returnLater()"></lib-button>

    </div>
</lib-modal-layout>
